import { Modal, Box, Typography, Button, Divider } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const ModalAvisoGenerado = ({ open, onClose, codigoAviso, colors }) => (
  <Modal
    open={open}
    onClose={onClose}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
  >
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 460,
        bgcolor: colors.primary[400],
        borderRadius: "12px",
        borderTop: "4px solid #4caf50",
        boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
        outline: "none",
        overflow: "hidden",
      }}
    >
      {/* Main content */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        px={5}
        pt={5}
        pb={4}
        gap={2}
      >
        {/* Icon circle */}
        <Box
          sx={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            bgcolor: "rgba(76, 175, 80, 0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1,
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 52, color: "#4caf50" }} />
        </Box>

        <Typography
          id="modal-title"
          variant="h5"
          fontWeight="bold"
          color={colors.grey[100]}
        >
          Aviso de cobro generado
        </Typography>

        <Typography
          id="modal-description"
          variant="body1"
          color={colors.grey[300]}
          lineHeight={1.6}
        >
          El aviso de cobro{" "}
          <Box component="span" sx={{ fontWeight: "bold", color: "#4caf50" }}>
            {codigoAviso}
          </Box>{" "}
          ha sido generado y descargado correctamente.
        </Typography>
      </Box>

      <Divider sx={{ borderColor: colors.primary[300] }} />

      {/* Footer */}
      <Box display="flex" justifyContent="center" px={5} py={3}>
        <Button
          onClick={onClose}
          color="secondary"
          variant="contained"
          sx={{ px: 5, borderRadius: "8px" }}
        >
          Cerrar
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default ModalAvisoGenerado;
